import React from 'react';
import { Box, Container, Grid, Typography, useTheme, useMediaQuery } from '@mui/material';
import {
  Verified,
  FlashOn,
  Security,
  SupportAgent
} from '@mui/icons-material';

const WhyChooseUs = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const pillars = [
    {
      icon: <Verified sx={{ fontSize: 40 }} />,
      title: '100% Genuine Keys',
      description: 'Every product key is sourced from official channels and guarantees lifetime activation.',
    },
    {
      icon: <FlashOn sx={{ fontSize: 40 }} />,
      title: 'Instant Email Delivery',
      description: 'Your product key and download links are delivered instantly to your inbox upon checkout.',
    },
    {
      icon: <Security sx={{ fontSize: 40 }} />,
      title: 'Secure Checkout',
      description: 'All payments are processed securely with SSL encryption. Get GST-compliant invoices.',
    },
    {
      icon: <SupportAgent sx={{ fontSize: 40 }} />,
      title: '24/7 Expert Support',
      description: 'Our customer support team is always available to help you with installation and activation.',
    },
  ];

  return (
    <Box sx={{ pt: isMobile ? 4 : 8, pb: isMobile ? 6 : 8, background: 'linear-gradient(135deg, #0a1628 0%, #0e3a7a 50%, #0e6ada 100%)' }}>
      <Container maxWidth="lg">
        <Typography variant={isMobile ? "h5" : "h3"} align="center" gutterBottom sx={{ mb: isMobile ? 4 : 8, color: '#FFF', fontWeight: 800 }}>
          Why Choose AR Infotech?
        </Typography>
        <Grid container spacing={6}>
          {pillars.map((pillar, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Box sx={{ textAlign: 'center' }}>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    mb: 3,
                    color: '#87CEEB',
                    transition: 'transform 0.3s',
                    '&:hover': { transform: 'scale(1.1)' }
                  }}
                >
                  {pillar.icon}
                </Box>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 700, color: '#FFF' }}>
                  {pillar.title}
                </Typography>
                <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.75)', lineHeight: 1.7, mx: 2 }}>
                  {pillar.description}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default WhyChooseUs;
